import React from "react";

import { SettingsConfirmModal } from "../../../../components/modal/SettingsConfirmModal";
import { TrashSvg } from "../../../../components/svg/TrashSvg";
import { WarningExclaimSvg } from "../../../../components/svg/WarningExclaimSvg";
import { WorkTypeConfirmModalsProps } from "../model/workTypeEditor.types";

export const WorkTypeConfirmModals: React.FC<WorkTypeConfirmModalsProps> = ({
  workType,
  isDeleteOpen,
  isDeleting,
  onCloseDelete,
  onConfirmDelete,
  blocker,
}) => (
  <>
    {isDeleteOpen && workType && (
      <SettingsConfirmModal
        onClose={onCloseDelete}
        onConfirm={onConfirmDelete}
        isLoading={isDeleting}
        icon={<TrashSvg />}
        title={`Delete ‘${workType.name}’ work type?`}
        description={"Do you want to permanently delete this work type?"}
        confirmText={"Delete"}
        variant={"danger"}
      />
    )}
    {blocker.state === "blocked" && (
      <SettingsConfirmModal
        onClose={() => blocker.reset?.()}
        onConfirm={() => blocker.proceed?.()}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={"Unsaved changes"}
        description={
          "You have unsaved changes to this work type. If you leave now, your changes won't be saved."
        }
        confirmText={"Leave without saving"}
        cancelText={"Stay on page"}
        variant={"warning"}
        confirmFirst
      />
    )}
  </>
);
